<template lang="html">
    <div class="app">

        <Header></Header>
        <TypesMenu></TypesMenu>

        <div class="section section-grey py-5">
            <div class="container" v-if="categories">
                <h1 class="text-center mb-4" v-if="batch.final">Rezultate FINALE!!!</h1>
                <h1 class="text-center mb-4" v-else>Rezultate partiale</h1>
                <div class="text-center mb-4">
                    <router-link :to="{name: 'rank', params: {type: this.$route.params.type}}" class="btn btn-primary btn-lg"><i class="fas fa-trophy"></i> {{rankButtonText}}</router-link>
                    <div class="mt-4" v-if="!batch.final">
                        {{batch.textNext}}
                    </div>
                </div>
            </div>
        </div>
        <div class="section section-white section-shadow py-5">
            <div class="container">
                <div class="row mb-4">
                    <div class="col-sm-4 col-6 mb-4" v-for="(category, index) in categories">
                        <router-link :to="{name: 'category', params: {id: index}}">
                            <div class="card card-category text-center">
                                <img :src="'https://www.fotografi-cameramani.ro/upload/concursuri/imagine/logo/' + category.thumb">
                                <div class="card-img-overlay align-items-end d-flex">
                                    <div class="title py-2">
                                        <div :to="{name: 'category', params: {id: index}}" v-if="category.materials">
                                            {{category.name}}
                                        </div>
                                        <div class="soon" v-else>
                                            {{category.name}}
                                            <br/>
                                            <small><i>Urmeaza</i></small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>

                <h2 class="text-center mb-4">Tombola de Know-How</h2>
                <div class="row">
                    <div class="col-sm-3 col-6" v-for="(kw, index) in batch.ws">
                        <div class="card mb-4">
                            <div class="card-body text-center">
                                <div class="ws">
                                    <div class="logo mb-2">
                                        <img :src="wsThumbUrl(kw.img)">
                                    </div>
                                    <div class="title mb-2">
                                        <span v-html="kw.name"></span>
                                    </div>
                                    <div class="text-success" v-if="knowHow[index]">
                                        Castigator: <b>{{knowHow[index].winner}}</b>
                                    </div>
                                    <div class="soon" v-else>
                                        <small><i>Urmeaza</i></small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <PromoMembers></PromoMembers>
        <Sponsors></Sponsors>
        <PromoClients></PromoClients>
        <Stt></Stt>
    </div>
</template>

<script>

import Header from '../components/snippets/Header.vue'
import Stt from '../components/snippets/Stt.vue'
import TypesMenu from '../components/snippets/TypesMenu.vue'
import Sponsors from '../components/snippets/Sponsors.vue'
import PromoMembers from '../components/snippets/PromoMembers.vue'
import PromoClients from '../components/snippets/PromoClients.vue'

import { mapState, mapActions, mapGetters } from 'vuex'

export default {
    name: 'Index',
    components: {
        Header,
        TypesMenu,
        Sponsors,
        PromoMembers,
        PromoClients,
        Stt
    },
    props: {
    },
    computed: {
        ...mapState('general', {
            batch: 'batch'
        }),

        ...mapGetters('general', {
            categories: 'categories',
            knowHow: 'knowHow',
            rankButtonText: 'rankButtonText'
        }),
    },
    watch: {
        '$route.params.type': function (id) {
            this.init()
        }
    },
    data: function() {
        return {}
    },
    mounted() {
        this.init();
    },
    methods: {
        ...mapActions('general', {
            getBatch: 'getBatch'
        }),

        init() {
            this.getBatch(this.$route.params.type);
        },

        updateBatch() {

        },

        wsThumbUrl(imagine) {

            if(this.$route.params.type == 'fotografie') {
                return 'https://www.fotografi-cameramani.ro/layout/concurs_anual_v2_inscrieri_foto/images/2020/' + imagine;
            }

            if(this.$route.params.type == 'videografie') {
                return 'https://www.fotografi-cameramani.ro/layout/concurs_anual_v2_inscrieri_video/images/2020/' + imagine;
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.card-img-overlay {
    padding: 0px;
    margin-bottom: 5%;
}

.card-category {
    .title {

        background: rgba(0,0,0,0.6);
        width: 100%;

        .soon {
            color: white;
            // opacity: 0.5;
        }
    }
}

</style>
